<template>
  <VanDialog
    v-model:show="modalStore.showReplyEditModal"
    :showConfirmButton="false"
    :title="$t(`Reply.edit`)"
    class="max-w-md"
    closeOnClickOverlay
  >
    <div class="mt-3" />
    <ReplyInput
      :key="modalStore.replyEditReply?.id"
      :moment="modalStore.replyEditMoment"
      :reply-target="modalStore.replyEditReply"
      :update-reply="modalStore.replyEditReply"
      @reply-updated="modalStore.showReplyEditModal = false"
      :entity="modalStore.replyEditEntity"
      :entity-type="modalStore.replyEditType"
      :mate="modalStore.replyEditMate"
    />
  </VanDialog>
</template>

<script setup lang="ts">
import { useGlobalModal } from "@/stores/globalModal";

const modalStore = useGlobalModal();
</script>
